import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Modal from 'react-bootstrap/Modal';
import RecordPane from './RecordPane';

function ActivityPage(props) {

    const [getStartPos, setStartPos] = React.useState(0);
    const [getModal, setModal] = React.useState(false);

    const itemsPerPage = 10;

    let i = 0;
    for (i = 0; i < props.Index.Index.length; i++)
    {
        if (props.Index.Index[i].Name === "-Activity")
        {
            break;
        }
    }

    let actid = props.ActivityId;
    let actlist = props.Index.Index[i].Index[actid];

    const clickNext = () =>
    {
        let n = getStartPos + itemsPerPage;
        if (n <= actlist.All.length)
        {
            setStartPos(n);
        }
    }

    const clickPrev = () =>
    {
        setStartPos(Math.max(0, getStartPos - itemsPerPage));
    }

    const clickShowModal = () =>
    {
        setModal(true);
    }

    let pages = [];
    
    if (getStartPos >= 0)
    {
        pages.push(
            <div key={pages.length} className="mb-4">
                <Badge className="btn mr-1" bg="success" onClick={clickPrev}>Prev</Badge>
                <Badge className="btn mr-1" pill={true}>{getStartPos/itemsPerPage + 1}</Badge>
                <Badge className="btn mr-1" bg="secondary" onClick={clickShowModal}>/ {Math.floor(actlist.All.length/itemsPerPage) + 1}</Badge>
                <Badge className="btn mr-1" bg="success" onClick={clickNext}>Next</Badge>
            </div>
        )

        if (getModal)
        {
            let items = [];

            for (let p = 0; p < actlist.All.length; p += itemsPerPage)
            {
                items.push(
                    <Badge key={items.length} className="btn mr-1" pill={true}
                        onClick={() => { setStartPos(p); setModal(false); }}
                        >
                        {p/itemsPerPage + 1}
                    </Badge>
                )
            }

            pages.push(
                <Modal key={pages.length} show={getModal} onHide={() => {setModal(false)}}>
                    <Modal.Body>
                        {items}
                    </Modal.Body>
                </Modal>
            )
        }

        let n = 0;
        for (let m = getStartPos; m < actlist.All.length; m++)
        {
            if (n >= itemsPerPage) break;

            pages.push(<RecordPane
                key={pages.length}
                Index={props.Index}
                RecIndex={actlist.All[m]}
                Favorite={props.Favorite}
                UpdateFavorite={props.UpdateFavorite}
            ></RecordPane>);

            n++;
        }
    }

    return <div>
        {pages}
        </div>
}

export default ActivityPage;
